import type { FaireProductEntity } from "../../entity_types/product";

export const p_vfym3kcnjk: FaireProductEntity = {
  token: "p_vfym3kcnjk",
  type: "product",
  name: "TECHNICALLY - Strappy Cage Wedge Heel",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/46ab9c4b0ce4b7033ece85deda3b224c1756186db25eab479b3a76ad39117dc4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/215389a13753b50d7c8ce7b2224e7d5abf135dd954228975d68718a1a6d4baac.jpeg",
    "https://cdn.faire.com/fastly/74ca366d130f01fc23270c03a752680cb495ab0cc825af490344a0fb93c87ae5.jpeg",
    "https://cdn.faire.com/fastly/c6265e90ef9a0e0194f4a59bfd28567ff817fc4a1d5c5ce627f13cde1a39e0da.jpeg",
    "https://cdn.faire.com/fastly/e178b1a3e85b2039d202c9bdd122f79883498fa3a5014013637c742052d12bee.jpeg",
    "https://cdn.faire.com/fastly/b65a217ea54d74efc87461c09c9c42a781488b2107e81955846b3a3414a83427.jpeg",
    "https://cdn.faire.com/fastly/3ef4952bdb2804dcae1c04f71e0bbb2db1fdf648397c01acb20d33bf65386033.jpeg",
    "https://cdn.faire.com/fastly/93b3d22eae4df5a23822c47bc117520b4737b3cce47e4f4673162c3de6359991.jpeg",
    "https://cdn.faire.com/fastly/676733aff6bdb0ac49a0fc015e849ad7d0274d5712934e5e0802df52fe04c7a9.jpeg",
  ],
  priceDollars: 12.75,
  description:
    "A playful twist on a barely-there heel. Designed with curved cage-like straps and a sleek slip-on silhouette, this sandal adds texture and shape while still feeling light and effortless. The mix of bold brights and classic neutrals makes it an easy statement piece for day or night.\nOOTD\nStyle with a satin midi skirt and fitted tank for a fun summer dinner look, or pair with oversized denim and a tiny shoulder bag for an early-2000s inspired vibe. The brighter colors also look so cute with breezy white linen sets or sheer layering pieces.",
  tags: [],
  msrpDollars: 25.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:12.549Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
